import { useEffect, useRef } from "react";

export const usePrevious = (value: any, defaultValue: any) => {
  const currRef = useRef(defaultValue); //To have a synchronized value before making a change, you need to pass the current value.

  //useLayoutEffect for see the change before ui rendered
  useEffect(() => {
    currRef.current = value;
  }, [value]);

  return currRef.current;
};
